// Block contacts

$(function () {
  const $popover = $('[data-toggle="popover"]')
  $popover.popover();
  $popover.click(function() {
    $popover.not(this).popover('hide');
  });
})
